<template>
    <div class="slideshow-container">
        <div style="position: relative; width: 100%; height: 100%;">

            <div class="option" ref="optionID">
                <img v-bind:src="'/pages/img/' + currentOption">
            </div>

            <div class="buttonsContainer">
                <div style="position: relative; width: 100%; height: 100%; display: flex; align-items: center;">
                    <div class="custom-button-a custom-button-style" v-on:click="userChangeOption(-1)" style="width: 60px; height: 60px;background-color: black; margin-left: -40px; position: absolute;">
                        <span style="transform: scaleX(-1);"></span>
                    </div>
                    <div class="custom-button-a custom-button-style" v-on:click="userChangeOption(1)" style="width: 60px; height: 60px;background-color: black; margin-left: calc(100% - 20px); position: absolute;">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.slideshow-container {
    display: block;
    width: inherit;
    height: inherit;
    border-radius: 15px;
    box-shadow: 0 0 0 3px #a6a6a6;
    position: absolute;
    margin: auto;
}
.blind .slideshow-container {
    box-shadow: 0 0 0 3px #FFFF00;
}
/* Hide the images by default */
.option {
  height: 80%;
  width:  80%;
  margin-top: 10%;
  margin-left: 10%;
  position: absolute;
}
.option img {
  height: 100%;
  max-width: 100%;
  display: block;
  margin: auto;
}
.fadeA {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  animation-name: fade;
  animation-timing-function: cubic-bezier(.03,.65,.34,1.31);
  animation-fill-mode: forwards;
}
.fadeB {
  -webkit-animation-name: fadeB;
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  animation-name: fadeB;
  animation-timing-function: cubic-bezier(.03,.65,.34,1.31);
  animation-fill-mode: forwards;
}
.buttonsContainer {
    width: 100%;
    height: 40%;
    margin-top: 30%;
    position: absolute;
}
.slideshow-container .custom-button-a span {
background-image: url("/pages/img/botones/regular/buttonArrowRight.svg");
background-repeat: no-repeat;
background-position: center;
width: 60%;
height: 60%;
}
.blind .slideshow-container .custom-button-a span {
background-image: url("/pages/img/botones/regular/buttonBlindArrowRight.svg");
}
@-webkit-keyframes fade {
  from {transform: scale(0.1)}
  to {transform: scale(1)}
}

@keyframes fade {
  from {transform: scale(0.1)}
  to {transform: scale(1)}
}
@-webkit-keyframes fadeB {
  from {transform: scale(0.1)}
  to {transform: scale(1)}
}

@keyframes fadeB {
  from {transform: scale(0.1)}
  to {transform: scale(1)}
}
</style>
<script>
    export default {
        props: ['number'],
        data() {
            return {
                slideIndex:0,
                lastFade:0,
                dbId:"undefined",
                options:[""]
            }
        },
        computed: {
            currentOption(){
                return this.options[this.slideIndex]
            }         
        },
        methods: {
            saveInput(){
                this.$db.options.put({
                    id: this.dbId,
                    option: this.slideIndex
                }).catch(function(error){
                    console.log("error saving option: " + error);
                    return;
                });
                console.log("success saving option: " + this.slideIndex);
            },
            async loadInput(){
                var value = await this.$db.options.get({
                id: this.dbId,
                }).catch(function(error){
                    console.log("error loading option: " + error);
                });
                if (value === undefined) return;
                console.log(value);
                this.setOption(value.option);
            },
            loadOptions(options) {
                this.options = options;
                console.log("options loaded! " + this.options);
            },
            userChangeOption(n) {
              this.setOption(this.slideIndex + n);
              this.saveInput();
            },
            setOption(n) {
                if (n >= this.options.length) {
                    n = 0;
                }
                if (n < 0) {
                    n = this.options.length-1
                }

                this.slideIndex = n;

                var optionElement = this.$refs.optionID;

                if (this.lastFade == 0) {
                    optionElement.classList.remove("fadeA");
                    optionElement.classList.add("fadeB");
                    this.lastFade = 1;
                }
                else if (this.lastFade == 1) {
                    optionElement.classList.remove("fadeB");
                    optionElement.classList.add("fadeA");
                    this.lastFade = 0;
                }
            }
        },
        async created() {
            this.loadInput();
        },
        mounted(){
            this.dbId = `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number}-imageOptionSlider-${this.number}`;

            this.loadInput();
            this.setOption(this.slideIndex);
        }
    }
</script>
